module.exports = __webpack_public_path__ + "img/produk-placeholder.3a500ad7.webp";